(() => {
'use strict';
const desktop = matchMedia('(min-width:651px)');
let drawer = null, pending = null, timer = null, requestId = 0;
const catalog = () => document.getElementById('kk-catalog');
const filterForm = () => document.getElementById('kt-filter-form');
function closeDrawer(restore = true, returnFocus = true) {
 if (!drawer) return;
 const state = drawer; drawer = null;
 if (restore) state.controls.forEach(({el,value,checked}) => {el.value=value;el.checked=checked;});
 state.root.dataset.filterOpen='false';state.sidebar.removeAttribute('role');state.sidebar.removeAttribute('aria-modal');
 state.inert.forEach(([el,previous])=>{el.inert=previous;});
 document.body.classList.remove('kc-filter-lock');
 state.button.setAttribute('aria-expanded','false');
 if (returnFocus && state.button.isConnected) state.button.focus();
}
function openDrawer(button) {
 const root=catalog(),form=filterForm(),sidebar=root?.querySelector('#kc-sidebar');
 if(!sidebar||!form||desktop.matches)return;
 closeDrawer();
 const controls=[...form.elements].map(el=>({el,value:el.value,checked:el.checked}));
 const inert=[...document.querySelectorAll('.kt-header-wrap,.kk-footer,.kk-ribbon,.kc-results,.kc-categories,.kc-intro,.kc-breadcrumb')].filter(el=>!sidebar.contains(el)).map(el=>[el,el.inert]);
 drawer={root,sidebar,button,controls,inert};root.dataset.filterOpen='true';sidebar.setAttribute('role','dialog');sidebar.setAttribute('aria-modal','true');
 inert.forEach(([el])=>{el.inert=true;});document.body.classList.add('kc-filter-lock');button.setAttribute('aria-expanded','true');sidebar.querySelector('[data-filter-close]')?.focus();
}
function formURL(form) {
 const url=new URL(form.action,location.origin),data=new FormData(form);
 for(const [key,value] of data)if(String(value).trim()!=='')url.searchParams.append(key,value);
 for(const [key,value] of new URLSearchParams(location.search))if(key.startsWith('preview_')||key==='_fd'||key==='pb')url.searchParams.set(key,value);
 return url;
}
function validPrices(form) {
 const min=form.querySelector('[name="filter.v.price.gte"]'),max=form.querySelector('[name="filter.v.price.lte"]');
 if(min&&max){max.min=min.value||'0';}
 return form.reportValidity();
}
async function updateCollection(url,{push=true,focus=null}={}) {
 const root=catalog();if(!root||!root.querySelector('#kt-filter-form'))return;
 clearTimeout(timer);closeDrawer(false,false);pending?.abort();pending=new AbortController();const controller=pending,id=++requestId;
 const destination=new URL(url,location.origin);destination.searchParams.delete('section_id');
 if(destination.origin!==location.origin)return;
 for(const [key,value] of new URLSearchParams(location.search))if((key.startsWith('preview_')||key==='_fd'||key==='pb')&&!destination.searchParams.has(key))destination.searchParams.set(key,value);
 const fetchURL=new URL(destination);if(root.dataset.sectionId)fetchURL.searchParams.set('section_id',root.dataset.sectionId);
 root.setAttribute('aria-busy','true');root.classList.add('kt-updating');
 try{
  const response=await fetch(fetchURL.pathname+fetchURL.search,{signal:controller.signal,headers:{Accept:'text/html'}});
  if(!response.ok)throw new Error('Collection response unavailable');
  const html=await response.text();if(id!==requestId)return;
  const parsed=new DOMParser().parseFromString(html,'text/html'),replacement=parsed.getElementById('kk-catalog');
  if(!replacement?.querySelector('#kt-filter-form'))throw new Error('Collection section unavailable');
  const expanded=[...root.querySelectorAll('.kc-facet')].map(el=>el.open);
  replacement.querySelectorAll('.kc-facet').forEach((el,i)=>{if(expanded[i]!==undefined)el.open=expanded[i];});
  root.replaceWith(replacement);initialize(replacement);
  if(push)history.pushState({kidzFilters:true},'',destination.pathname+destination.search+destination.hash);
  let target=null;
  if(focus?.name)target=[...replacement.querySelectorAll('input,select')].find(el=>el.name===focus.name&&el.value===focus.value);
  if(!target&&focus?.results)target=replacement.querySelector('.kc-results');
  if(target)target.focus({preventScroll:true});
 }catch(error){
  if(error.name==='AbortError'||id!==requestId)return;
  location.assign(destination.pathname+destination.search+destination.hash);
 }finally{
  if(id===requestId){pending=null;catalog()?.removeAttribute('aria-busy');catalog()?.classList.remove('kt-updating');}
 }
}
function initialize(root=catalog()) {
 if(!root?.querySelector('#kt-filter-form'))return;
 root.classList.add('kt-filters-ready');
 const min=root.querySelector('[name="filter.v.price.gte"]'),max=root.querySelector('[name="filter.v.price.lte"]');if(min&&max)max.min=min.value||'0';
}
initialize();
document.addEventListener('shopify:section:load',()=>initialize());
document.addEventListener('shopify:section:unload',e=>{
 if(e.target.contains(catalog())){closeDrawer(false,false);pending?.abort();clearTimeout(timer);}
});
document.addEventListener('click',e=>{
 const open=e.target.closest('.kc-openfilters');if(open){e.preventDefault();openDrawer(open);return;}
 if(e.target.closest('[data-filter-close]')){e.preventDefault();closeDrawer();return;}
 const link=e.target.closest('#kk-catalog .kc-activefilters a,#kk-catalog .kc-filterhead a,#kk-catalog .kt-pagination a,#kk-catalog .kt-empty a');
 if(link&&e.button===0&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey){e.preventDefault();updateCollection(link.href,{focus:{results:true}});}
});
document.addEventListener('submit',e=>{
 if(e.target.id!=='kt-filter-form')return;
 e.preventDefault();if(!validPrices(e.target))return;
 updateCollection(formURL(e.target),{focus:{results:true}});
});
document.addEventListener('change',e=>{
 const el=e.target;
 if(el.id==='kt-sort'){
  const form=filterForm();if(!form)return;
  const url=new URL(location.href);url.searchParams.set('sort_by',el.value);url.searchParams.delete('page');updateCollection(url,{focus:{name:el.name,value:el.value}});return;
 }
 if(!el.closest('#kt-filter-form'))return;
 const form=filterForm();if(!form)return;
 if(el.type==='number'){const min=form.querySelector('[name="filter.v.price.gte"]'),max=form.querySelector('[name="filter.v.price.lte"]');if(min&&max)max.min=min.value||'0';}
 if(!desktop.matches)return;
 clearTimeout(timer);timer=setTimeout(()=>{if(validPrices(form))updateCollection(formURL(form),{focus:{name:el.name,value:el.value}});},180);
});
document.addEventListener('keydown',e=>{
 if(!drawer)return;
 if(e.key==='Escape'){e.preventDefault();closeDrawer();return;}
 if(e.key!=='Tab')return;
 const all=[...drawer.sidebar.querySelectorAll('a[href],button,input,select,summary')].filter(el=>!el.disabled&&el.getClientRects().length);
 if(!all.length)return;
 if(e.shiftKey&&document.activeElement===all[0]){e.preventDefault();all.at(-1).focus();}
 else if(!e.shiftKey&&document.activeElement===all.at(-1)){e.preventDefault();all[0].focus();}
});
desktop.addEventListener('change',()=>closeDrawer());
window.addEventListener('popstate',()=>{if(filterForm())updateCollection(new URL(location.href),{push:false,focus:{results:true}});});
})();
